<template>
  <MainLayout
    :initialDrawerExpanded="false"
    contentClass="pa-md-4"
    :has-sidebar="false"
  >
    <template #header>
      <div class="overline">
        <PageBack />
      </div>
    </template>

    <template #content>
      <v-row class="pa-2">
        <v-col cols="12">

          <h1><v-icon x-large class="mr-2 mb-2">mdi-help-circle-outline</v-icon>Aide</h1>
          <p class="h3">Bienvenue dans la section d'aide. Ici, vous trouverez des informations pour vous guider dans l'utilisation de l'application.</p>
        </v-col>
        <v-col cols="12" md="4">


          <h2><v-icon large>mdi-view-quilt-outline</v-icon>Écrans</h2>

          <h3><v-icon class="mr-2">mdi-login</v-icon>Écran de connexion</h3>
          <p>Sur cet écran, vous pouvez vous connecter à votre compte {{ $theme.brand.appName }} en utilisant vos identifiants.</p>
          <v-alert outlined type="warning" dense>
            Pour l'instant, cette fonctionnalité est en cours de développement.
            Les utilisateurs peuvent se connecter automatiquement sans authentification.
          </v-alert>
          
          <h3><v-icon class="mr-2">mdi-chat-outline</v-icon>Écran de chat</h3>
          <p>Sur cet écran, vous pouvez discuter avec votre assistant <strong>{{ $theme.brand.assistantName }}</strong>.</p>
          <p>La barre de gauche vous permet de <strong>choisir un projet</strong>, d'en <strong>démarrer</strong> un nouveau, ou de <strong>rechercer</strong> dans les projets existants. </p>

          <h3><v-icon class="mr-2">mdi-cog-outline</v-icon>Écran des paramètres</h3>
          <p>Sur cet écran, vous pouvez configurer votre assistant {{ $theme.brand.assistantName }}.</p>

          <h4><v-icon class="mr-2">mdi-account-outline</v-icon>Paramètres utilisateur</h4>
          <p>Vous pouvez <strong>choisir votre nom d'utilisateur.</strong></p>

          <h4><v-icon class="mr-2">mdi-chat-outline</v-icon>Paramètres OpenAI</h4>
          <p>Vous pouvez <strong>activer</strong> ou <strong>désactiver</strong> les appels sur l'API de ChatGPT.</p>
          <v-alert outlined type="info" dense>
            Désactiver les appels API permet de simuler les réponses de l'assistant, ce qui est utile pour tester l'application sans consommer de crédits API.
          </v-alert>

          <h4><v-icon class="mr-2">mdi-folder-table-outline</v-icon>Paramètres des projets</h4>
          <p>Vous pouvez <strong>gérer</strong> vos projets et leur historique.</p>
          <v-alert outlined type="info" dense>
            Par défaut les conversations sont stockées localement sur votre appareil. Vous pouvez activer ou désactiver cette fonctionnalité selon vos préférences.
          </v-alert>
          <v-alert outlined type="error" dense>
            L'historique des conversations n'est pas encore synchronisé entre les appareils. Cette fonctionnalité sera disponible dans une future mise à jour.
          </v-alert>
          <p>Les boutons <strong>télécharger, importer et supprimer</strong> les projets permet de faciliter la gestion des projets.</p>


          <h4><v-icon class="mr-2">mdi-message-reply-text</v-icon>Paramètres du prompt</h4>
          <p>Vous pouvez <strong>surcharger</strong> le prompt système.</p>
          <v-alert outlined type="info" dense>
            En modifiant le prompt système, vous pouvez personnaliser le comportement de l'assistant {{ $theme.brand.assistantName }} selon vos besoins.
          </v-alert>
          
        </v-col>

        <v-col cols="12" md="4">
          <h2><v-icon large>mdi-television-guide</v-icon>Utilisation de l'assistant {{ $theme.brand.assistantName }}</h2>
          <h4><v-icon class="mr-2">mdi-plus-circle-outline</v-icon>Nouveau projet</h4>
          <p>Pour démarrer une nouvelle conversation avec l'assistant {{ $theme.brand.assistantName }}, cliquez sur le bouton <strong>Nouveau projet</strong> dans la barre latérale gauche.</p>
          <v-alert outlined type="info" dense>
            Pour chaque nouveau projet, une nouvelle conversation est créée.
            Vous pouvez ainsi gérer plusieurs projets simultanément.
          </v-alert>

          <h4><v-icon class="mr-2">mdi-file-search</v-icon>Rechercher un projet</h4>
          Vous pouvez rechercher un projet existant en utilisant le champ de recherche dans la barre latérale gauche.
          <v-alert outlined type="info" dense>
            La recherche vous permet de retrouver rapidement un projet en fonction de son titre ou du contenu de la conversation.
          </v-alert>

          <h4><v-icon class="mr-2">mdi-wall</v-icon>Expert plâtre et isolation</h4>
          Ce bot est spécialisé dans les domaines du plâtre et de l'isolation. Il peut vous aider à concevoir des solutions d'isolation adaptées à vos besoins.
          <v-alert outlined type="warning" dense>
            Il n'y a que ce bot pour l'instant. D'autres experts seront disponibles dans de futures mises à jour.
          </v-alert>
        </v-col>
      </v-row>
    </template>
  </MainLayout>
</template>

<script>
import PageBack from '@/components/ui/PageBack.vue'
import MainLayout from '@/layout/MainLayout.vue';
export default {
  name: 'HelpView',
  components: { PageBack, MainLayout }
}
</script>

<style>

</style>